import styled from "@emotion/styled";
import { Switch } from "@mui/material";

const AppSwitch = styled(Switch)(({ theme }) => ({
  width: 28,
  height: 16,
  padding: 0,
  display: 'flex',
  '&:active': {
    '& .MuiSwitch-thumb': {
      width: 15,
    },
    '& .MuiSwitch-switchBase.Mui-checked': {
      transform: 'translateX(9px)',
    },
  },
 '& .MuiSwitch-switchBase': {
  padding: 2,

  '& + .MuiSwitch-track': {
    backgroundColor: '#00b278', // OFF state color
    opacity: 1,
  },

  '&.Mui-checked': {
    transform: 'translateX(12px)',
    color: '#fff',

    '& + .MuiSwitch-track': {
      backgroundColor: '#00b278', // ON state color
      opacity: 1,
    },
  },
},

'& .MuiSwitch-track': {
  borderRadius: 16 / 2,
  opacity: 1,
  backgroundColor: '#00b278',
  boxSizing: 'border-box',
},
  '& .MuiSwitch-thumb': {
    boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
    width: 12,
    height: 12,
    borderRadius: 6,
    transition: theme.transitions.create(['width'], {
      duration: 200,
    }),
  },
 
}));

export default AppSwitch